import { render, staticRenderFns } from "./ProductMappingSelect.vue?vue&type=template&id=50cdc52b"
import script from "./ProductMappingSelect.vue?vue&type=script&lang=ts"
export * from "./ProductMappingSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports